import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_EXTERNAL_NO_RANGES = 'GET_EXTERNAL_NO_RANGES';
export const DELETE_RANGE = 'DELETE_RANGE';
export const DELETE_CONNECT_RANGE = 'DELETE_CONNECT_RANGE';

export const actions = createSagaActionTypes('EXTERNAL_NO_RANGES', [
  GET_EXTERNAL_NO_RANGES,
  DELETE_RANGE,
  DELETE_CONNECT_RANGE
]);
